import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    institutionId: z.string(),
  }),
  response: z.string(),
};
